import { Component, inject } from '@angular/core';
import { PileService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PileCreateDto,
  PileDto,
  PileExcelDownloadDto,
  PileUpdateDto,
} from '../proxy/planning/dtos/pile';
import { PILE_CONFIG, PILE_FIELDS } from './pile.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pile',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, PileService, ConfirmationService],
  templateUrl: './pile.html',
  styleUrl: './pile.scss',
})
export class Pile extends BaseHierarchicalCrudComponent<
  PileDto,
  PileCreateDto,
  PileUpdateDto,
  PileExcelDownloadDto
> {
  service = inject(PileService);
  config = PILE_CONFIG;
  fields = PILE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PileDto): PileUpdateDto {
    return {
      name: data.name,
      number: data.number,
      isPefcCertified: data.isPefcCertified,
      inactivationDate: data.inactivationDate,
      woodAge: data.woodAge,
      finalLogyardWoodAge: data.finalLogyardWoodAge,
      pileTypeId: data.pileTypeId,
      pileStatusId: data.pileStatusId,
      locationId: data.locationId,
      logyardId: data.logyardId,
      finalProductId: data.finalProductId,
      contractTypeGroupId: data.contractTypeGroupId,
      geneticMaterialTypeId: data.geneticMaterialTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Pile';
  }
}
